import axios from "axios";

export const Axios = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_HOST,
    withCredentials: true
})

export const AxiosGuest = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_HOST,
})